export const getValidatedValue = (
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    newValue: any,
    oldValue: number,
    max: number,
    min: number
): number => {
    const newNumber = +newValue;
    if (isNaN(newNumber)) {
        return oldValue;
    }
    if (!isNaN(max) && newNumber > max) {
        return max;
    }
    if (!isNaN(min) && newNumber < min) {
        return min;
    }
    return Math.round(newNumber);
};

export const calculateValue = (type: string, value: number, increment: number, max: number, min: number) => {
    const factor = type === "decrement" ? -1 : 1;
    const newValue = value + factor * increment;
    return getValidatedValue(newValue, value, max, min);
};

export const getNumberValue = (string: string): number => {
    const number = string === "" ? NaN : +string;
    return number;
};
